import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = async (route: ActivatedRouteSnapshot, _: RouterStateSnapshot, authData: AuthGuardData): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;
  const requiredRole = route.data['role'];

  const hasRequiredRole = (role: string): boolean =>
    Object.values(grantedRoles.realmRoles).some((roles) => {
      return roles.includes(role)
    });

  if (!hasRequiredRole(requiredRole) || !authenticated) {
    authData.keycloak.logout();
    return false;
  }
  if (authenticated && hasRequiredRole(requiredRole)) {
    return true;
  }

  return true;
};

export const XlogAuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
